var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 21.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-help-support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.24,13.1c-.13-.1-1.17-.89-4.05-1.08a1.08,1.08,0,0,1-.46-.22,2.31,2.31,0,0,1-.5-.41c-.22-.26-.47-.49-.68-.78a6,6,0,0,0-3-2.42c-.27-.13-1.32,0-.82.73,0,0,1.6,2.21,1.7,2.39A3.66,3.66,0,0,0,4,12c.18.2.37.38.55.58a9.42,9.42,0,0,1-1.25-.86,2.67,2.67,0,0,1-.24-.42c-.1-.16-.2-.32-.31-.47s-.27-.38-.41-.57l-.56-.7a5.14,5.14,0,0,1-.34-.44.76.76,0,0,1,.58-1.26c0-.09-.26-2.36-.3-2.74C1.63,4,1.51,3.2.88,3a.33.33,0,0,0-.4.09A4.31,4.31,0,0,0,.22,4.51a37.38,37.38,0,0,0-.21,4,29.37,29.37,0,0,0,2.73,6c.6.72,5.31,3.43,5.31,3.43a2.47,2.47,0,0,1,1,1.68v1.91h5.08V19.78c0-.32.07-.65.11-1a3.65,3.65,0,0,0,0-1.34A8,8,0,0,0,11.24,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.78,4.51a4.31,4.31,0,0,0-.27-1.45.33.33,0,0,0-.4-.09c-.63.22-.74,1-.86,2.12,0,.38-.28,2.65-.3,2.74a.76.76,0,0,1,.58,1.26,5,5,0,0,1-.34.44l-.56.7c-.14.19-.28.38-.41.57s-.21.31-.31.47a2.63,2.63,0,0,1-.24.42,9.41,9.41,0,0,1-1.25.86c.18-.2.37-.38.55-.58a3.66,3.66,0,0,0,.58-.66c.1-.18,1.67-2.38,1.7-2.39.5-.7-.54-.86-.82-.73a6,6,0,0,0-3,2.42c-.21.29-.46.51-.68.78a2.31,2.31,0,0,1-.5.41,1.08,1.08,0,0,1-.46.22c-2.88.19-3.92,1-4.05,1.08a8,8,0,0,0-3,4.37,3.64,3.64,0,0,0,0,1.34c0,.32.09.65.11,1v1.75h5.08V19.61a2.47,2.47,0,0,1,1-1.68s4.71-2.71,5.31-3.43a29.4,29.4,0,0,0,2.73-6A37.26,37.26,0,0,0,29.78,4.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.27,
    cy: 2.26,
    r: 2.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.73,
    cy: 2.8,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.57,13c.26-.24.51-.44.72-.6l0,0a5.32,5.32,0,0,1,1.87-.83L20,10.23V8.94a12.14,12.14,0,0,1,.63,2.51,13.59,13.59,0,0,1,1.68-.26C21.8,8,21,6.64,19.2,5.53a5.67,5.67,0,0,0-.91-.41l-.55.55-.53-.56h0a6.23,6.23,0,0,0-1.9,1.22,6,6,0,0,0-1.52-1.27,5.84,5.84,0,0,0-.94-.42l-.56.57-.55-.57h0a4.84,4.84,0,0,0-1.14.61c-1.71,1.15-2.45,2.67-3,5.94a13.65,13.65,0,0,1,1.73.26A14.56,14.56,0,0,1,10,8.84V11.6h0a5.13,5.13,0,0,1,1.71.78l0,0c.21.16.46.36.72.6a3.25,3.25,0,0,1,2.21-1.9h0l.35.37.35-.37h0A3.24,3.24,0,0,1,17.57,13ZM15,11a1.53,1.53,0,1,1,1.51-1.53A1.53,1.53,0,0,1,15,11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpSupport);
export default __webpack_public_path__ + "static/media/icon-help-support.8d250140c720da20602824a5b1a85a20.svg";
export { ForwardRef as ReactComponent };